export const initialState = {
    filter: {
      code: null,
      description: null,
      status: null,
      name: null,
      page: null,
      size: null
    },
    isFilter: false,
    typeAction: null
  };
  
  const searchLabelReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_LABEL":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction,
        };
      default:
        return state;
    }
  };
  
  export default searchLabelReducer;
  